/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeploymentSyncRequest} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'
import {DeploymentSyncResponse} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'


export const deploymentSync = (request: DeploymentSyncRequest, options?: CashRequestOptions) => post<DeploymentSyncRequest, DeploymentSyncResponse>("/2.0/cash/deployment-sync", request, {...options, rejectOnError: true })